(function(){
  const cartIcon=document.querySelector('.cart-icon[href="/cart"]');
  const drawer=document.querySelector('.cd-main-d5');
  if(!cartIcon||!drawer)return;

  function positionDrawer(){
    const rect=cartIcon.getBoundingClientRect();
    const gap=12;
    const top=Math.max(rect.bottom+gap,0);
    const right=Math.max(window.innerWidth-rect.right,16);
    drawer.style.top=top+'px';
    drawer.style.right=right+'px';
    drawer.style.maxHeight='calc(100vh - '+top+'px - 20px)';
  }

  positionDrawer();
  window.addEventListener('resize',positionDrawer);

  if(window.innerWidth >= 750){
    cartIcon.addEventListener('mouseenter', () => {
        positionDrawer();
        drawer.classList.add('active');
    });

    // cartIcon.addEventListener('mouseleave', () => {
    //     drawer.classList.remove('active');
    // });

}
  document.addEventListener('click',e=>{
    const isClickInsideDrawer=drawer.contains(e.target);
    const isClickOnCartIcon=cartIcon.contains(e.target);
    if(!isClickInsideDrawer&&!isClickOnCartIcon&&drawer.classList.contains('active')){
      drawer.classList.remove('active');
    }
  });

 window.rerender = async function (addedKey = null) {
  const res = await fetch('/?section_id=d5-cart-drawer');
  const text = await res.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  const newElems = doc.querySelectorAll('[render-d5]');
  const currentElems = document.querySelectorAll('[render-d5]');
  const oldCount = document.querySelector('.cart-count-d5');
  const newCount = doc.querySelector('.cart-count-d5');
  if(oldCount && newCount){
    oldCount.innerHTML = newCount.innerHTML;
  }
  currentElems.forEach((el, i) => {
    const newEl = newElems[i];
    if (newEl) el.innerHTML = newEl.innerHTML;
  });
  drawer?.classList.remove('atc-loading-d5');
  if (window.innerWidth < 750 && addedKey) {
    const newItem = doc.querySelector(`[id="${addedKey}"]`);
    if (newItem) {
      const notifContainer = document.querySelector('.cart-notification-d5 .cn-items-d5');
      notifContainer.innerHTML = newItem.outerHTML;
      const notification = document.querySelector('.cn-main-d5');
      notification.classList.add('active');
    }
  }
};

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('.add_to_cart');

    if(btn) btn.textContent = 'Adding...'
    const isDesktop = window.innerWidth >= 750;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
      });
      if (!isDesktop) {
        window.location.href = '/cart';
        return;
      }
      await rerender();
      if(btn) btn.textContent = 'Add to Bag'
      if (drawer) {
        positionDrawer();
        drawer.classList.add('active');
      }
    } catch (err) {
      console.error(err);
    }
  });
});

  // const quickAds = document.querySelectorAll('.openCartBtn');
  // quickAds.forEach(q => {
  //   q.addEventListener('click', async () => {
  //     drawer.classList.add('atc-loading-d5');
  //     setTimeout(() => {
  //       drawer.classList.add('active');
  //     }, 200);
  //       await rerender();
  //   })
  // })
  document.addEventListener('click',async e=>{
    const minus=e.target.closest('.cd-qty-minus-d5');
    const plus=e.target.closest('.cd-qty-plus-d5');
    if(!minus&&!plus)return;
    e.preventDefault();
    const item=e.target.closest('[line-item]');
    if(!item)return;
    const key=item.getAttribute('line-item');
    const input=item.querySelector('.cd-qty-input-d5');
    let qty=parseInt(input.value,10);
    if(plus)qty++;
    if(minus)qty--;
    if(qty<1)qty=0;
    item.classList.add('loading');
    await fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})
    });
    await rerender();
  });

  document.body.addEventListener('click', async function (e) {
    const saveBtn = e.target.closest('.cd-save-later-d5');
    if (!saveBtn) return;
    e.preventDefault();
    const item = saveBtn.closest('[line-item]');
    if (!item) return;
    const key = item.getAttribute('line-item');
    saveBtn.classList.add('loading');
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      await rerender();
    } catch (err) {
      console.error(err);
      saveBtn.classList.remove('loading');
    }
  });

  let oldVariantQuantity;
  let oldVariantId;
  document.body.addEventListener('click', async function (e) {
  const trigger = e.target.closest('.cd-item-options-d5')
  if (!trigger) return
  e.preventDefault()
  oldVariantId = trigger.getAttribute('variant-id');
  oldVariantQuantity = trigger.getAttribute('data-quantity');
  const modal = document.querySelector('.cd-variant-update-modal-d5')
  const modalInner = modal.querySelector('.cdv-um-inner-d5')
  const url = trigger.dataset.url
  modal.classList.add('active')
  try {
    const response = await fetch(url)
    const html = await response.text()
    const temp = document.createElement('div')
    temp.innerHTML = html
    const mainProduct = temp.querySelector('.main-product-d5')
    temp.querySelector('.mp-update-btn-d5').classList.add('disabled');
    modal.classList.add('loading-nul');
    if (mainProduct) modalInner.appendChild(mainProduct)
  } catch (error) {
    console.error('Error loading variant options:', error)
  }
  document.querySelectorAll('.wishlist-button-d5').forEach(button => {
              updateWishlistState(button);
            });
})

  document.body.addEventListener("click",function(e){
    const valueEl=e.target.closest(".mp-value-d5");
    if(!valueEl)return;
    const optionWrapper=valueEl.closest(".mp-option-values-d5");
    if(!optionWrapper)return;
    optionWrapper.querySelectorAll(".mp-value-d5").forEach(el=>el.classList.remove("active"));
    valueEl.classList.add("active");
    document.querySelector('.mp-update-btn-d5').classList.add('disabled');
    const productEl=document.querySelector(".mp-product-json-d5");
    if(!productEl)return;
    const productJson=JSON.parse(productEl.textContent);
    const selectedOptions=[];
    document.querySelectorAll(".mp-option-values-d5").forEach(group=>{
      const active=group.querySelector(".mp-value-d5.active");
      if(active)selectedOptions.push(active.textContent.trim());
    });
    const matchedVariant=productJson.variants.find(v=>v.options.every((opt,i)=>opt===selectedOptions[i]));
    if(matchedVariant){
      const mainProduct=document.querySelector(".main-product-d5");
      if(mainProduct){
        const url=mainProduct.getAttribute("data-url");
        fetch(`${url}&variant=${matchedVariant.id}`)
        .then(res=>res.text())
        .then(html=>{
          const temp=document.createElement("div");
          temp.innerHTML=html;
          const newInfo=temp.querySelector(".mp-product-info-d5");
          const oldInfo=document.querySelector(".mp-product-info-d5");
          const btn = temp.querySelector('.mp-update-btn-d5')
          if(oldVariantId == btn.getAttribute('data-variant')){
            btn.classList.add('disabled');

            // btn.textContent = 'Already in Cart'
          }
          if(newInfo&&oldInfo)oldInfo.innerHTML=newInfo.innerHTML;
          document.querySelectorAll('.wishlist-button-d5').forEach(button => {
              updateWishlistState(button);
            });
        });
      }
    }
  });


  document.body.addEventListener('click', async function (e) {
  const updateBtn = e.target.closest('#cart-drawer-d5 .mp-update-btn-d5');
  if (!updateBtn || updateBtn.classList.contains('disabled')) return;
  e.preventDefault();
  const newVariantId = updateBtn.getAttribute('data-variant');
  if (!oldVariantId || !newVariantId || oldVariantId === newVariantId) return;
  const modal = document.querySelector('.cd-variant-update-modal-d5');
  closeModal(select = '.cd-variant-update-modal-d5');
  drawer.classList.add('atc-loading-d5');
  setTimeout(() => {
     positionDrawer();
     drawer.classList.add('active');
  }, 200);
  const qty = oldVariantQuantity ? oldVariantQuantity : 1
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: oldVariantId, quantity: 0 })
    });
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: newVariantId, quantity: qty })
    });
    await rerender();
    modal.classList.remove('active');
  } catch (error) {
    console.error('Error updating variant:', error);
  } finally {
    drawer.classList.remove('atc-loading-d5');
  }
  document.querySelectorAll('.wishlist-button-d5').forEach(button => {
    updateWishlistState(button);
  });
});

document.body.addEventListener('click', async function (e) {
  const link = e.target.closest('.mp-color-switch-link-d5');
  if (!link) return;
  e.preventDefault();
  const modal = link.closest('.cd-variant-update-modal-d5, .quick-add-modal-d5, .cart-add-modal-d5');
  if (!modal) return;
  const modalInner = modal.querySelector('.cdv-um-inner-d5, .qa-inner-d5');
  if (!modalInner) return;
  const url = link.dataset.url;
  try {
    const response = await fetch(url);
    const html = await response.text();
    const temp = document.createElement('div');
    temp.innerHTML = html;
    const mainProduct = temp.querySelector('.main-product-d5');
    if (mainProduct) {
      const oldMainProduct = modalInner.querySelector('.main-product-d5');
      if (oldMainProduct) oldMainProduct.remove();
      modalInner.appendChild(mainProduct);
    }
  } catch (error) {
    console.error('Error switching color:', error);
  }
  document.querySelectorAll('.wishlist-button-d5').forEach(button => {
    updateWishlistState(button);
  });
});

function closeModal(select) {
  const modal = document.querySelector(select);
  const appendedSection = modal.querySelector('.main-product-d5');
  if (appendedSection) appendedSection.remove();
  modal.classList.remove('active', 'loading-nul');
}

document.body.addEventListener("click", function (e) {
  if (e.target.hasAttribute('close-update-modal-d5')) {
    e.preventDefault();
    closeModal(select = '.cd-variant-update-modal-d5');
  }
  if (e.target.hasAttribute('qa-close-modal-d5')) {
    e.preventDefault();
    closeModal(select = '.qa-inner-d5');
    document.querySelector('.quick-add-modal-d5').classList.remove('active', 'loading-nul');
  }
});

document.querySelectorAll('[cn-close-d5]').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelector('.cn-main-d5').classList.remove('active');
  })
})

document.addEventListener('click',async function(e){
  const el=e.target.closest('.cn-up-option-d5');
  const modal = document.querySelector('.quick-add-modal-d5');
  if(!el)return;
  e.preventDefault();
  const url=el.getAttribute('data-url');
  if(!url)return;
  modal.classList.add('active');
  try{
    const response=await fetch(url);
    if(!response.ok)throw new Error();
    const htmlText=await response.text();
    const parser=new DOMParser();
    const doc=parser.parseFromString(htmlText,'text/html');
    const productContent=doc.querySelector('.main-product-d5');
    if(!productContent)return;
    const targetContainer=document.querySelector('.qa-inner-d5');
    if(!targetContainer)return;
    targetContainer.appendChild(productContent);
    modal.classList.add('loading-nul');
  }catch(err){
    console.error(err);
  }
  document.querySelectorAll('.wishlist-button-d5').forEach(button => {
    updateWishlistState(button);
  });
});

document.body.addEventListener('click', async function (e) {
  const button = e.target.closest('#cart-notification-d5 .atc-btn-d5');
  if (!button || window.innerWidth >= 750) return;
  const variantId = button.getAttribute('data-variant');
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    });
    window.location.href = '/cart';
  } catch (err) {
    console.error(err);
  }
});


})();
